// extracted by mini-css-extract-plugin
module.exports = {"howItWorksCard":"referrals_howItWorksCard__5F9U4"};